import { API } from '../../customise/constants/api';
import { ICarDetails } from '../../../../common/model/ICarDetails';
import { IDeal } from '../../../../common/model/IDeal';
import httpClient from '../../common/api/httpClient';
import urlRoute from '../../common/service/urlRoute';
import axios, { CancelTokenSource } from 'axios';

let dealUpdateSource: CancelTokenSource;

const dealApi = {
  getForCar(carConfig: ICarDetails): Promise<IDeal> {
    if (dealUpdateSource) {
      dealUpdateSource.cancel();
    }

    const url = urlRoute.createUrl(API.CONFIGURE_DEAL_PATH);

    dealUpdateSource = axios.CancelToken.source();

    return httpClient.post(url, carConfig, { cancelToken: dealUpdateSource.token }).then(response => {
      dealUpdateSource = null;

      return response.data as IDeal;
    });
  },

  save(): Promise<IDeal> {
    const url: string = urlRoute.createUrl(API.DEAL_SAVE_PATH);

    return httpClient.patch(url).then(response => response.data as IDeal);
  },
};

export default dealApi;
